function isRefObject(value) {
  return value != null && typeof value !== "function";
}
function isRefCallback(value) {
  return typeof value === "function";
}
/**
 * Assign the given ref to a target, either a React ref object or a callback which takes the ref as its first argument.
 */

function setRef(refTarget, ref) {
  if (isRefObject(refTarget)) {
    //@ts-ignore
    refTarget.current = ref;
  } else if (isRefCallback(refTarget)) {
    refTarget(ref);
  }
}
/**
 * Creates a ref handler which assigns the ref returned by React for a mounted component to a field on the target object.
 * The target object is usually a component class.
 *
 * If provided, it will also update the given `refProp` with the value of the ref.
 */

function refHandler(refTargetParent, refTargetKey, refProp) {
  return function (ref) {
    refTargetParent[refTargetKey] = ref;
    setRef(refProp, ref);
  };
}

export { isRefCallback, isRefObject, refHandler, setRef };
//# sourceMappingURL=additionalExports.js.map
